<template>
	<div
		v-if="loading"
		v-loading="true"
		style="height: 50px; margin: 30px 0;"
	/>
	<div v-else>
		<template v-if="collection.length">

			<template v-if="view === 'table'">
				<el-table
					:data="collection"
					:show-header="false"
					style="width: 100%"
				>
					<el-table-column width="70">
						<template slot-scope="scope">
							<img
								@click="openEdit(scope.row)"
								:src="scope.row.thumbnailPath"
								class="media-thumbnail small with-cursor"
							/>
						</template>
					</el-table-column>
					<el-table-column>
						<template slot-scope="scope">
							<a
								@click.prevent="openEdit(scope.row)"
								href="#"
								class="special"
							>
								{{ scope.row.fileName }}
							</a>
						</template>
					</el-table-column>
					<el-table-column prop="resolution" width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.mediaType === 'VIDEO'" class="table-small align-center">
								<div class="color-light">
									{{ translations.labels.duration }}:
								</div>
								{{ scope.row.videoLength }}s
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="resolution" width="120">
						<template slot-scope="scope">
							<div class="table-small align-center">
								<div class="color-light">
									{{ translations.labels.resolution }}:
								</div>
								{{ scope.row.resolution }}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="createdAt" width="120">
						<template slot-scope="scope">
							<div class="table-small align-center">
								<div class="color-light">
									{{ translations.labels.createdAt }}:
								</div>
								{{ convertDate(scope.row.createdAt, 'date') }}
							</div>
						</template>
					</el-table-column>
					<el-table-column align="right" width="100">
						<template slot-scope="scope">
							<el-dropdown
								v-if="!isTeamViewer"
								@command="handleCommand"
								size="medium"
								placement="bottom-end"
							>
								<el-button plain size="mini">
									<span class="el-icon-s-tools" />
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										:command="{ action: 'edit', row: scope.row }"
									>
										{{ translations.labels.edit }}
									</el-dropdown-item>
									<el-dropdown-item
										:command="{ action: 'delete', id: scope.row.id }"
										:disabled="!isTeamViewer && !scope.row.used"
									>
										{{ translations.labels.delete }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
				<Pagination :pagination="pagination" />
			</template>

			<template v-if="view === 'grid'">
				<div class="media-grid" :class="{ 'alt': inDialog }">
					<div

						v-for="(item, index) in collection"
						:key="index"
						class="media-grid-item"
					>
						<div
							v-if="inDialog"
							@click="chooseAsset(item)"
							:style="{ backgroundImage: `url(${item.thumbnailPath})` }"
							class="media-grid-item-image"
						>
						</div>
						<div
							v-else
							@click="openEdit(item)"
							:style="{ backgroundImage: `url(${item.thumbnailPath})` }"
							class="media-grid-item-image"
						>
						</div>
						<div v-if="!inDialog && !isTeamViewer && !item.used" class="media-grid-item-button">
							<span
								@click="openDelete(item.id)"
								class="el-icon-circle-close"
							/>
						</div>
					</div>
				</div>
				<div
					v-if="collection.length !== pagination.total"
					class="media-load"
				>
					<el-button
						@click="changePage(pagination.currentPage + 1)"
						:loading="buttonLoading"
						plain
					>
						{{ translations.labels.loadMore }}
					</el-button>
				</div>
			</template>

		</template>
		<el-empty
			v-else
			:description="translations.labels.noFiles"
			:image-size="120"
		/>
	</div>
</template>

<script>
import { EventBus } from '@/services/event-bus'
import convertDate from '@/services/mixins/convertDate'

export default {
	name: 'MediaTab',
	props: {
		buttonLoading: Boolean,
		collection: Array,
		inDialog: Boolean,
		loading: Boolean,
		pagination: Object,
		view: String
	},
	mixins: [
		convertDate
	],
	components: {
		Pagination: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Search/Pagination')
	},
	methods: {
		chooseAsset (value) {
			EventBus.$emit('choose-asset', value)
		},
		openEdit (value) {
			EventBus.$emit('open-edit', value)
		},
		openDelete (value) {
			EventBus.$emit('open-delete', value)
		},
		handleCommand (el) {
			if (el.action === 'edit') {
				EventBus.$emit('open-edit', el.row)
			}
			if (el.action === 'delete') {
				EventBus.$emit('open-delete', el.id)
			}
		},
		changePage (page) {
			EventBus.$emit('change-pagination', page)
		}
	}
}
</script>
